export default __webpack_public_path__ + "static/media/Vector.51f6cb71.svg";